import React, { useEffect,useContext } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { randomExtension } from "utils/utils";
import userActions from "redux/modules/user/actions";
import { connect } from "react-redux";
import toast from "react-hot-toast";
import { SubscriptionContext } from "context/subscription";

const EmailVerification = ({ setUserData }) => {
  const { http, localstorage } = global.services;

  const history = useHistory();
  const query = useQuery();
  const token = query.get("token");
  const { resetSubscription } = useContext(SubscriptionContext);

  // Read Meta cookies from the browser
  const getCookie = (name) => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  };

  const verify = async () => {
    try {
      const { data } = await http.post("email-verification", { token }); 
      const extension = randomExtension();
      if (data.user.role !== "admin") {
        resetSubscription();/**Add subscription after verfication confirmed*/
        toast.success("Your email has been verified!");
        localstorage.set("user_data", JSON.stringify(data));
        setUserData(data);
        
        // Check if running on production before making the complete-registration call
        var host = (typeof window !== 'undefined' && window.location && window.location.hostname) ? window.location.hostname : '';
        var PROD_HOSTS = ['app.milestonespage.com'];
        var isProd = PROD_HOSTS.indexOf(host) !== -1;

        console.log('Host:', host, 'isProd:', isProd);

        if (isProd) {
          // Fire Facebook Pixel CompleteRegistration event and send CAPI event
          const fbp = getCookie('_fbp');
          const fbc = getCookie('_fbc'); // Will be null if user did not arrive via a Meta ad
          
          http.post("public/complete-registration", { 
            email: data.user.email, 
            event_source_url: window.location.href,
            fbp: fbp,
            fbc: fbc
          }).then((response) => {
            try {
              if (typeof window.fbq === 'function' && response?.data?.event_id) {
                const eventId = response.data.event_id;
                const subscriptionType = response.data.type || 'f'; // 'p' for paid, 'f' for free
                console.log('Firing fbq CompleteRegistration with event_id:', eventId, 'type:', subscriptionType);
                window.fbq('track', 'CompleteRegistration',
                  {
                    registration_method: 'email',
                    type: subscriptionType,
                  },
                  {
                    eventID: eventId,
                  }
                );
              }
            } catch (e) {
              // Don't block the UI if tracking fails
              // eslint-disable-next-line no-console
              console.warn('fbq track failed', e);
            }
          }).catch((err) => {
            console.warn('complete-registration call failed', err);
          });
        }
            
        return history.replace(
          `/${data.user.username}-${extension}/profile/${data.profile.id}`
        );
      } else {
        toast.error("This site is only accessible by customer users");
      }
    } catch (err) {
      console.log("error@verify", err);
      throw err;
    }
  };

  useEffect(() => {
    if (token) verify();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return <></>;
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUserData: (params) => {
      dispatch(userActions.setUserData(params));
    },
  };
};

export default connect(null, mapDispatchToProps)(EmailVerification);

const useQuery = () => {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
};
